import { Pipe, PipeTransform } from '@angular/core';
import {
  AratData,
  Assessment,
  AssessmentSubType,
  BbsData,
  BbsDataSet,
  BbtData,
  CustomData,
  NhptData,
  SubTestDataSet,
  TwoHandsNumberDataSet,
} from '../services/model';

@Pipe({
  name: 'aratScorePercent',
  standalone: true,
})
export class AratScorePercentPipe implements PipeTransform {
  damageLevels = [
    { icf: 4, min: 96, max: 100, color: '#ff0000a8' }, // Schädigung voll ausgeprägt
    { icf: 3, min: 50, max: 95, color: '#f5363975' }, // Schädigung erheblich ausgeprägt
    { icf: 2, min: 25, max: 49, color: 'orange' }, // Schädigung mäßig ausgeprägt
    { icf: 1, min: 5, max: 24, color: '#cdb832bd' }, // Schädigung leicht ausgeprägt
    { icf: 0, min: 0, max: 4, color: 'lightgray' }, // Schädigung nicht vorhanden
  ];

  transform(assessment: Assessment, side: 'left' | 'right' | 'none' = 'none', subType: AssessmentSubType): number {
    let score = -1;
    if (assessment.type === 'ARAT') {
      const data = assessment.data as AratData;
      let subData: SubTestDataSet<TwoHandsNumberDataSet> = data.grip;
      if (subType === 'grip') {
        subData = data.grip;
      }
      if (subType === 'grasp') {
        subData = data.grasp;
      }
      if (subType === 'gross') {
        subData = data.gross;
      }
      if (subType === 'pinch') {
        subData = data.pinch;
      }
      if (side === 'left') {
        score = this.getScore(subData.scoreLeftPercentage);
      }
      if (side === 'right') {
        score = this.getScore(subData.scoreRightPercentage);
      }
    }

    return score > -1 ? score : -1;
  }

  hasValue(value: any): boolean {
    return value !== undefined && value !== null;
  }

  getScore(score: number | null | undefined): number {
    // umrechnung auf erfüllung statt Schädigung
    if (this.getPercent(score) < 0) {
      return -1;
    }
    return 100 - this.getPercent(score);

    // ehemals: icfScore zurückggeben...
    // return this.getIcf(this.getPercent(score));
  }

  getPercent(score: number | null | undefined): number {
    if (score !== undefined && score !== null && score > -1) {
      if (score <= 1 && score >= 0) {
        return Math.round(score * 100);
      } else {
        return -2;
      }
    } else {
      return -1;
    }
  }
  getIcf(score: number | null | undefined): number {
    if (score !== undefined && score !== null) {
      if (score === -2) {
        return -2;
      } else if (score === -1) {
        return -1;
      } else {
        for (const level of this.damageLevels) {
          if (score >= level.min && score <= level.max) {
            return level.icf;
          }
        }
      }

      return -1;
    } else {
      return -1;
    }
  }
}
